<template>
  <div class="section section__acceleration">
    <div class="section__wrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionWrapper"
}
</script>